import { AjaxResponse } from 'rxjs/ajax';
import { Observable } from 'rxjs';
import { EndpointsName, put } from '../../Auth';
import { Area, ProcessLine, ProcessType } from "../../types";
import { withLogger } from '../LogerServices';

export const buildPutACKEndpoint = (area: Area, paramGroup: string, paramName: string, line?: ProcessLine) =>
    `/mlc/${area}/${line ? `${line}/` : ''}ack/${paramGroup}/${paramName}`;

export const buildPutCancelAkcEndpoint = (area: Area, paramGroup: string, paramName: string, line?: ProcessLine) =>
    `/mlc/${area}/${line ? `${line}/` : ''}cancel/${paramGroup}/${paramName}`;

export const putWithLogger = (fc: any): Observable<AjaxResponse> =>
    withLogger(put(EndpointsName.BBF, fc(), null), ProcessType.ACKNOWLEDGE)

// ACK
export const putAknowledgementOfINTBAlarmObserver = (paramGroup: string, paramName: string, line?: ProcessLine): Observable<AjaxResponse> =>
    putWithLogger(() => buildPutACKEndpoint(Area.INTB, paramGroup, paramName, line));
export const putAknowledgementOfTBCFAlarmObserver = (paramGroup: string, paramName: string): Observable<AjaxResponse> =>
    putWithLogger(() => buildPutACKEndpoint(Area.TBCF, paramGroup, paramName));

// CANCEL
export const putCancelAknowledgementOfINTBAlarmObserver = (paramGroup: string, paramName: string, line?: ProcessLine): Observable<AjaxResponse> =>
    putWithLogger(() => buildPutCancelAkcEndpoint(Area.INTB, paramGroup, paramName, line));
export const putCancelAknowledgementOfTBCFAlarmObserver = (paramGroup: string, paramName: string): Observable<AjaxResponse> =>
    putWithLogger(() => buildPutCancelAkcEndpoint(Area.TBCF, paramGroup, paramName));